import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Label, PanelType } from 'office-ui-fabric-react';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import React, { Component } from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Scriba from 'react-scriba';
import ImmocomContext from '../../contexts/ImmocomContext.js';
import { DataTache } from '../../data/DataTache.jsx';
import { MaxLengths } from '../../data/MaxLenghts.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxDomaine } from '../ComboBox/ComboBoxDomaine';
import { ComboBoxEtat } from '../ComboBox/ComboBoxEtat';
import { ComboBoxFonctionnalite } from '../ComboBox/ComboBoxFonctionnalite';
import { ComboBoxPriorite } from '../ComboBox/ComboBoxPriorite';
import { ComboBoxSalariesScribaNet } from '../ComboBox/ComboBoxSalariesScribaNet';
import { ComboBoxTypeDeDemande } from '../ComboBox/ComboBoxTypeDeDemande';
import { EUIDatePicker } from '../EUI/EUIDatePicker.jsx';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { EUIToggle } from '../EUI/EUIToggle.jsx';
import { DetailsListTicket } from '../List/DetailsListTicket';
import { ComboBoxesPerimetreAdministratif } from '../Outils/ComboboxesPerimetreAdministratif.jsx';
import { ComboBoxesPerimetreEiffage } from '../Outils/ComboboxesPerimetreEiffage.jsx';
import { PickerCompte } from '../Picker/PickerCompte';

// KP - 26/06/2023 : composant raccordé à ImmocomContext pour tests
export class FicheTache extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        idTache: undefined,
        isOpen: false,
        masquerOngletTickets: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null,
    };

    static defaultState = {
        tache: {
            assigneA: "0",
            dateDebutPrevisionnelle: null,
            dateDemande: new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate()),
            dateFinPrevisionnelle: null,
            demandeur: "",
            idAgence: 0,
            idDepartementAdministratif: "0",
            idDomaine: 0,
            idEtat: 0,
            idFonctionnalite: 0,
            idOperation: 0,
            idRegion: 0,
            idRegionAdministrative: 0,
            idTypeDeDemande: 0,
            idVilleAdministrative: "0",
            loginCompte: "",
            perimetreNational: true,
            priorite: "0",
            traiteSupervision: false,
        },
        affichagePerimetreNational: true,
        affichagePerimetreEiffage: false,
        affichagePerimetreAdministratif: false,
        affichageTache: true,
        affichageTickets: false,
        editorState: EditorState.createEmpty(),
        onActiveBoutonEnregistrer: false,
        ongletActif: "projet",
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheTache.defaultState };
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement du projet en cours...");

        const { idTache } = this.props;

        DataTache._detailler(idTache).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const tache = responseFetch.reponseAPIobjet;
                let state = {
                    tache,
                    affichagePerimetreNational: !!tache.perimetreNational,
                    affichagePerimetreEiffage: !!tache.idRegion,
                    affichagePerimetreAdministratif: !!tache.idRegionAdministrative,
                };

                if (!!tache.description) {
                    const draft = htmlToDraft(tache.description);
                    const { contentBlocks, entityMap } = draft;
                    const content = ContentState.createFromBlockArray(contentBlocks, entityMap);
                    state.editorState = EditorState.createWithContent(content);
                }

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _getItems = () => {
        return [{
            key: "coller",
            name: "Coller",
            iconProps: { iconName: "Paste" },
            onClick: this._onCollerDepuisLePressePapier
        }, {
            key: "supprimer",
            name: "Supprimer",
            iconProps: { iconName: "Delete" },
            onClick: this._onConfirmationSuppressionImpressionEcran
        }];
    };

    _onSave = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const loadingMessageId = addMessage("loading", "Enregistrement du projet en cours...");

        const tache = {
            ...this.state.tache,
            description: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
        };

        DataTache._enregistrer(tache).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onSave);
            else fetchMessages(responseFetch);
            dismissMessage(loadingMessageId);
        });

    };

    _onChangeCompte = (loginCompte) => {
        const tache = { ...this.state.tache, loginCompte };
        this.setState({ tache: tache }, this._onVerificationFormulaire);
    };

    _onOpen = () => {
        const { idTache } = this.props;
        this.setState({ ...FicheTache.defaultState });
        if (!!idTache)
            this._chargementDonnees();
    };

    _onChangeChoiceGroupPerimetreEiffage = (ev, option) => {
        Immocom.perimetre()._onChangeChoiceGroupPerimetreEiffage(this, 'tache', ev, option);
    };

    _onVerificationFormulaire = () => {
        const tache = {
            ...this.state.tache,
            description: this.state.editorState.getCurrentContent().getPlainText()
        };
        Immocom.fiche()._validationFormulaire(this, "Tache", tache, this.props.idTache > 0 ? "Modification" : "Création");
    };

    render = () => {

        const { idTache, isOpen, masquerOngletTickets, onDismiss } = this.props;
        const { affichagePerimetreAdministratif, affichagePerimetreEiffage, affichagePerimetreNational, editorState, tache, onActiveBoutonEnregistrer, ongletActif } = this.state;

        let perimetre = undefined;
        if (affichagePerimetreNational) perimetre = "national";
        else if (affichagePerimetreEiffage) perimetre = "eiffage";
        else if (affichagePerimetreAdministratif) perimetre = "administratif";

        return <EUIPanel
            headerText={!!idTache ? `Modification du projet #${idTache}` : "Nouveau projet"}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={ongletActif === "projet" && this._onSave}
            type={PanelType.extraLarge}
            styles={{ content: { height: "100%" } }}
        >

            {!masquerOngletTickets && !!idTache &&
                <Pivot
                    linkSize={PivotLinkSize.large}
                    onLinkClick={(item, ev) => this.setState({ ongletActif: item.props.itemKey })}
                    selectedKey={ongletActif}
                >
                    <PivotItem headerText="PROJET" itemKey="projet" />
                    <PivotItem headerText="TICKETS" itemKey="tickets" />
                </Pivot>
            }

            {ongletActif === "tickets" &&
                <DetailsListTicket idTache={idTache} />
            }

            {ongletActif === "projet" &&
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl10">
                            <EUITextField
                                label="Titre"
                                maxLength={MaxLengths.tache.titre}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "tache", "titre", newValue, this._onVerificationFormulaire)}
                                required
                                value={tache.titre}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl2">
                            <EUIToggle
                                checked={tache.traiteSupervision}
                                label="Supervision"
                                offText="En attente"
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "tache", "traiteSupervision", isChecked, this._onVerificationFormulaire)}
                                onText="Traité"
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl4 ms-xxl2">
                            <EUIDatePicker
                                isRequired
                                label="Date demande"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "tache", "dateDemande", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                value={tache.dateDemande}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl4 ms-xxl2">
                            <ComboBoxTypeDeDemande
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "tache", "idTypeDeDemande", option.key, this._onVerificationFormulaire)}
                                selectedKey={tache.idTypeDeDemande}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl4 ms-xxl2">
                            <EUITextField
                                label="Demandeur"
                                maxLength={MaxLengths.tache.demandeur}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "tache", "demandeur", newValue, this._onVerificationFormulaire)}
                                value={tache.demandeur}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl4 ms-xxl2">
                            <ComboBoxSalariesScribaNet
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "tache", "assigneA", option.key !== "0" ? option.key : null, this._onVerificationFormulaire)}
                                selectedKey={tache.assigneA}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl8 ms-xxl4">
                            <PickerCompte
                                loginCompte={tache.loginCompte}
                                idSociete={1} // 1 = Eiffage
                                onChange={(loginCompte) => this._onChangeCompte(loginCompte)}
                                label="Compte"
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl1">
                            <ComboBoxPriorite
                                selectedKey={tache.priorite}
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "tache", "priorite", option.key, this._onVerificationFormulaire)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl3">
                            <ComboBoxEtat
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "tache", "idEtat", option.key, this._onVerificationFormulaire)}
                                selectedKey={tache.idEtat}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl4">
                            <ComboBoxDomaine
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetProprietes(this, "tache", [["idDomaine", option.key], ["idFonctionnalite", 0]], this._onVerificationFormulaire)}
                                selectedKey={tache.idDomaine}
                            />
                        </div>

                        <div className="ms-Grid-col ms-sm12 ms-lg6 ms-xl4">
                            <ComboBoxFonctionnalite
                                idDomaine={tache.idDomaine}
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "tache", "idFonctionnalite", option.key, this._onVerificationFormulaire)}
                                selectedKey={tache.idFonctionnalite}
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg8">
                            <ChoiceGroup
                                label="Périmètre"
                                options={[
                                    { key: "national", iconProps: { iconName: "World" }, text: "National" },
                                    { key: "eiffage", iconProps: { iconName: "GlobeFavorite" }, text: "Eiffage" },
                                    { key: "administratif", iconProps: { iconName: "HomeSolid" }, text: "Administratif" }
                                ]}
                                onChange={this._onChangeChoiceGroupPerimetreEiffage}
                                selectedKey={perimetre}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <EUIDatePicker
                                label="Date de début"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "tache", "dateDebutPrevisionnelle", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                                placeholder="Date"
                                value={tache.dateDebutPrevisionnelle}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <EUIDatePicker
                                label="Date de fin"
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "tache", "dateFinPrevisionnelle", Scriba.date().getChaineISOFromDate(date), this._onValidationSurSortieDeChamp)}
                                placeholder="Date"
                                value={tache.dateFinPrevisionnelle}
                            />
                        </div>
                    </div>

                    {perimetre === "eiffage" &&
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <ComboBoxesPerimetreEiffage
                                    afficherComboBoxProgramme={false}
                                    idAgence={tache.idAgence}
                                    idOperation={tache.idOperation}
                                    idProgramme={tache.idProgramme}
                                    idRegion={tache.idRegion}
                                    onChange={(event, option, index, value, item, perimetre) => {
                                        const { idRegion, idAgence, idOperation } = perimetre;
                                        const tache = { ...this.state.tache, idRegion, idAgence, idOperation };
                                        this.setState({ tache }, this._onVerificationFormulaire);
                                    }}
                                />
                            </div>
                        </div>
                    }

                    {perimetre === "administratif" &&
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <ComboBoxesPerimetreAdministratif
                                    idDepartementAdministratif={tache.idDepartementAdministratif}
                                    idOperation={tache.idOperation}
                                    idRegionAdministrative={tache.idRegionAdministrative}
                                    idVilleAdministrative={tache.idVilleAdministrative}
                                    onChange={(event, option, index, value, item, perimetre) => {
                                        const { idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation } = perimetre;
                                        const tache = { ...this.state.tache, idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation };
                                        this.setState({ tache }, this._onVerificationFormulaire);
                                    }}
                                />
                            </div>
                        </div>
                    }

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 mb-2">
                            <Label required>Description du projet</Label>
                            <Editor
                                editorState={editorState}
                                onBlur={this._onVerificationFormulaire}
                                onEditorStateChange={newValue => this.setState({ editorState: newValue })}
                                toolbar={{ options: ["inline", "blockType", "fontSize", "list", "textAlign", "history"] }}
                            />
                        </div>
                    </div>
                </div>
            }

        </EUIPanel>;

    };

};